import React, { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { marked } from 'marked';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

const InputTextareaRaw = commonComponentsRegistry.getLazyComponent('InputTextareaRaw');
const Modal = commonComponentsRegistry.getLazyComponent('Modal');

export type MarkdownModalProps = {
    onInsert: (html: string) => void;
    open: boolean;
    close: () => void;
};

export const MarkdownModal = ({ onInsert, open, close }: MarkdownModalProps) => {
    const intl = useIntl();
    const [markdown, setMarkdown] = useState('');

    const doClose = useCallback(() => {
        setMarkdown('');
        close();
    }, [close]);

    return (
        <Modal
            title={intl.formatMessage({ id: 'TINY_MCE_Insert_Markdown' })}
            open={open}
            closeHandler={doClose}
            enableClickAwayCloseModal
            buttons={[
                {
                    children: <FormattedMessage id="GLOBAL_Cancel" />,
                    color: 'cancel',
                    clickHandler: doClose,
                },
                {
                    children: <FormattedMessage id="GLOBAL_Insert" />,
                    color: 'valid',
                    disabled: !markdown,
                    clickHandler: () => {
                        onInsert(marked.parse(markdown, { async: false }).replace(/<br>/g, '<br><br>'));
                        doClose();
                    },
                },
            ]}>
            <InputTextareaRaw value={markdown} onChange={(e) => setMarkdown(e.target.value)} height={'400px'} />
        </Modal>
    );
};
